import React, { useState, useEffect } from "react";
import { useAppDispatch } from "../../../utils/Hooks";
import { bulkUpdateRecommendationRoutes } from "../../../store/reducers/LockedRecommendationsSlice";

interface Props {
    open: boolean
    ids: number[]
    initialComment?: string
    initialLocked?: boolean
    onClose: () => void
    onSaved: () => void
}

export const ModifyModal: React.FC<Props> = ({ open, ids, onClose, onSaved, initialComment, initialLocked }) => {

    const dispatch = useAppDispatch();

    const [comment, setComment] = useState<string>('');
    const [locked, setLocked] = useState<boolean>(false);

    useEffect(() => {
        if (!open) return;

        setComment(initialComment ?? '');
        setLocked(initialLocked ?? false);
    }, [open, initialComment, initialLocked]);

    if (!open) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                }}
                onClick={onClose}
            />
            <div style={{position: 'relative', zIndex: 1}}>
                <div
                    style={{
                        background: '#fff',
                        padding: '20px',
                        borderRadius: '8px',
                        width: '500px',
                        maxWidth: '90%',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                    }}
                >
                    <h2>Muuda valituid ({ids.length})</h2>

                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        style={{width: '100%', minHeight: '120px', marginTop: '10px'}}
                    />

                    <label style={{display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px', cursor: 'pointer', fontWeight: 600}}>
                        <input
                            type="checkbox"
                            checked={locked}
                            onChange={(e) => setLocked(e.target.checked)}
                        />
                        Lukustatud
                    </label>

                    <div style={{marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <button
                            style={{padding: '8px 14px', height: '38px', border: '1px solid #ccc', borderRadius: '6px', background: '#fff', cursor: 'pointer'}}
                            onClick={onClose}
                        >
                            Tühista
                        </button>

                        <button
                            style={{padding: '8px 14px', height: '38px', border: '1px solid #1976d2', borderRadius: '6px', background: '#1976d2', color: '#fff', cursor: 'pointer'}}
                            onClick={async () => {
                                await dispatch(bulkUpdateRecommendationRoutes({
                                    ids,
                                    comment,
                                    locked
                                }));
                                onSaved();
                            }}
                        >
                            Salvesta
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}